import GaiaLogo from './GaiaLogo'

export default GaiaLogo
// eslint-disable-next-line import/export
export * from './GaiaLogo'
